export default __webpack_public_path__ + "alberta-customer-id.d658ed3af0b7e97a88c9.svg";